module.exports = __webpack_public_path__ + "img/2018.16728447.png";